import React from 'react'

const TabsContext = React.createContext<any>(null)

export default TabsContext
